import { render, staticRenderFns } from "./TLSCard.vue?vue&type=template&id=0d948aad&"
import script from "./TLSCard.vue?vue&type=script&lang=js&"
export * from "./TLSCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports